import { render, staticRenderFns } from "./OrganisationsView.vue?vue&type=template&id=0e4a42e0&scoped=true"
import script from "./OrganisationsView.ts?vue&type=script&lang=ts&external"
export * from "./OrganisationsView.ts?vue&type=script&lang=ts&external"
import style0 from "./OrganisationsView.scss?vue&type=style&index=0&id=0e4a42e0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a42e0",
  null
  
)

export default component.exports